import { DashboardCtrl } from "./dashboard";
import { DashboardService } from "./service";

export function setup(module: ng.IModule) {
    module
        .service("OmniaDashboardService", DashboardService)

        .directive("omniaDashboard", DashboardCtrl.create);
}
